<template>
  <v-card color="#FFFFFF" class="main-card-success">
    <v-card-text>
      <div class="container">
        <div class="justify-content-center">
          <h3
            style="color:#1E0E62; font-size: 40px;line-height: 1.2; margin-bottom: 1rem;"
          >
            Usuario registrado exitosamente
          </h3>
          <div style="margin-bottom:3rem; font-size: 18px; line-height: 1.8;">
            <h4>
              Estimado <strong>{{ nombre }}</strong
              >, su usuario se ha registrado con éxito
            </h4>
            <p class="mb-5">
              Le damos una cordial bienvenida a <strong>SiGeMed</strong>
            </p>
            <p class="mb-5">
              Se le acaba de enviar un correo electrónico con sus datos de
              acceso.
            </p>
            <p class="mb-5">
              Usuario: <strong>{{ usuario }}</strong> <br />
              Contraseña: <strong>{{ clave }}</strong>
            </p>
          </div>
          <v-card-actions
            style="padding: 0; display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: wrap; gap: 1rem"
          >
            <v-btn
              color="#25DAC5"
              class="mx-0"
              style="border-radius: 10px; color: white; text-transform: none;height: 50px;width: 210px; box-shadow: none;"
              href="https://cloud.sigemed.com.ar"
            >
              Iniciar Sesión
            </v-btn>

            <a
              class="back-link"
              @click="salir"
              style="font-size: 14px; color: rgba(21, 20, 57, 0.4)"
              >Volver a SiGeMed</a
            >
          </v-card-actions>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data: (vm) => ({
    usuario: "",
    nombre: "",
    clave: "",
  }),
  methods: {
    salir() {
      window.location.href = "https://www.sigemed.com.ar";
    },
  },
  mounted() {
    this.usuario = this.$store.state.usuario;
    (this.nombre = this.$store.state.nombre),
      (this.clave = this.$store.state.clave);
  },
};
</script>
